import { render, staticRenderFns } from "./ProductDetail_Catalog.vue?vue&type=template&id=a64ff4b8&scoped=true"
import script from "./ProductDetail_Catalog.vue?vue&type=script&lang=js"
export * from "./ProductDetail_Catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ff4b8",
  null
  
)

export default component.exports